import SimpleTableList from '@/components/forms/SimpleTableList'
import TableColumn from '@/components/forms/TableColumn'
import Tables from '@/components/forms/Tables'
import Tools from '@/components/tools/Tools'
import WorkRepository from '@/shared/http/repositories/business/work'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import PDRRepository from '@/shared/http/repositories/pci/pdr'
import PDRObraAvaliacaoRepository from '@/shared/http/repositories/pci/pdrobraavaliacao'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import Roles from '@/shared/utils/roles.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { AgGridVue } from 'ag-grid-vue'
import { isEqual } from 'lodash'
import moment from 'moment'
import ConstructionTeam from '../components/construction/constructionTeam.vue'
import Cop from '../components/cop/cop.vue'
import DateEditor from '../components/DateEditor'
import EvaluationOrder from '../components/evaluationorder/evaluationorder.vue'
import FilesButton from '../components/FilesButton.vue'
import gridMixin from '../mixins/gridMixin'
import LayoutPdrSidebar from './components/layoutPdrSidebar'

export default {
  name: 'PDR',
  components: {
    AgGridVue,
    EvaluationOrder,
    SimpleTableList,
    DateEditor,
    FilesButton,
    Tables,
    TableColumn,
    Cop,
    ConstructionTeam,
    LayoutPdrSidebar
  },
  mixins: [gridMixin, CompanyMixin, PermissionMixin],
  props: {
    archivedParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formCheckListBonus: null,
      showFormBonus: false,
      gridItemsLot: null,
      itemObservation: null,
      itemImage: null,
      gridApi: null,
      pci: null,
      showCopOf: false,
      showStoppageHistory: false,
      showPdrLog: false,
      showExclusionPdr: false,
      showArchivePdr: false,
      showConstructionTeam: false,
      editExclusionObservation: null,
      editArchiveObservation: null,
      logPdr: null,
      stoppageHistory: null,
      tabIndex: 0,
      columnApi: null,
      selectedItemForm: null,
      selectedPdrObraID: null,
      selectedObraID: null,
      selectedMemberID: null,
      selectedMember: null,
      gridPdr: null,
      gridPdrColumns: null,
      formItems: [],
      showModalEvaluation: false,
      workRowData: [{}],
      workRowDataOrigin: [{}],
      finalEvaluationRowData: [{}],
      workColumnDefs: null,
      finalEvaluationColumnDefs: null,
      teamRowData: [{}],
      teamColumnDefs: null,
      gridItemsForm: [],
      teamForms: [],
      gridMembros: null,
      itensFormulario: [],
      showAvaliacaoModal: false,
      hideStatusDoneEnabled: false,
      evaluationEditing: false,
      evaluationCurrentRowIndex: -1,
      evaluationPressEnter: false,
      autoGroupColumnDef: { minWidth: 350 },
      isProcessingUpdate: false,
      // chamado 20103: fila e timer do auto-save vivem na instancia. Como window.work2update era
      // global e nenhum hook limpava o setTimeout, navegar PDR <-> PDR-arquivadas (pdrarchived.vue
      // monta o mesmo componente) deixava N loops vivos consumindo a mesma fila -> POSTs
      // concorrentes na mesma chave (ObraMembroID, PDRObraID, PDRFormularioItemID).
      work2update: [],
      processUpdateTimer: null,
      sendingBonus: false,
      finalEvaluationDataGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 30
      },
      workDataGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 30
      },
      itemsEvaluationDataGridOptions: {
        columnDefs: [
          { field: 'departamento', rowGroup: true, hide: true }
        ],
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 30,
        groupDisplayType: 'singleColumn'
      },
      teamDataGridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      workMemberID: '',
      workMemberName: '',
      totalWorkRows: 0,
      sideBar: {
        toolPanels: [
          {
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            minWidth: 225,
            width: 300,
            maxWidth: 500,
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true
            }
          },
          {
            id: 'filters',
            labelDefault: 'Filters',
            labelKey: 'filters',
            iconKey: 'filter',
            toolPanel: 'agFiltersToolPanel',
            minWidth: 300,
            width: 400,
            maxWidth: 500
          },
          {
            id: 'layout',
            labelDefault: 'Layout',
            labelKey: 'layout',
            iconKey: 'menu',
            toolPanel: 'LayoutPdrSidebar',
            minWidth: 300,
            maxWidth: 500,
            width: 400
          }
        ],
        position: 'right'
      }
    }
  },
  computed: {
    realTerm () {
      return (this.formCheckListBonus.prazoObra || 0) - (this.formCheckListBonus.paralisacoes || 0)
    },
    isArchived () {
      return this.$route.name === 'PdrArquivados'
    }
  },
  methods: {
    onLoad () {
      if (!this.isArchived || Object.keys(this.archivedParams).length) {
        loading.push()
        let params = {}
        if (this.archivedParams) params = this.archivedParams
        params.empresaID = this.company.id
        PDRRepository.GetPDRWorks({ params: params })
          .then(response => {
            if (response.data.data) {
              this.workRowData = [{}]
              this.workColumnDefs = null
              this.gridItemsForm = []
              this.finalEvaluationRowData = [{}]
              this.finalEvaluationColumnDefs = null
              this.teamColumnDefs = null
              this.teamRowData = [{}]
              this.teamForms = []

              if (response.data.data.length > 0) {
                const data = response.data.data[0]
                this.workColumnDefs = data.Headers
                this.workRowDataOrigin = data.Data
                this.hideStatusDoneEnabled = localStorage.getItem('hideStatusDoneEnabled') === 'true'

                if (this.hideStatusDoneEnabled) {
                  let filtered = data.Data.filter(d => {
                    let hasNotFinished = false

                    for (var opt in d) {
                      if (opt.startsWith('status_')) {
                        hasNotFinished = hasNotFinished || d[opt] < 3
                      }
                    }

                    return hasNotFinished
                  })
                  this.workRowData = filtered
                } else {
                  this.workRowData = this.workRowDataOrigin
                }
                // this.totalWorkRows = this.workRowData.length
                this.$nextTick(() => {
                  this.totalWorkRows = this.workDataGridOptions.api.rowModel.rowsToDisplay.length
                })
              }
            }
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            this.$nextTick(() => {
              if (this.workDataGridOptions.columnApi) this.workDataGridOptions.columnApi.autoSizeAllColumns()
              loading.close()
            })
          })
      }
    },
    evaluationLiquidValue (membro) {
      if (membro.valorZerado) {
        membro.valorLiquido = 0.00
      } else {
        var valor = (membro.nota / 10) * membro.valorBruto
        if (membro.reducao1 !== 0) {
          valor -= valor * membro.reducao1 / 100
        }
        if (membro.reducao2 !== 0) {
          valor -= valor * membro.reducao2 / 100
        }
        if (membro.adicional !== 0) {
          valor += valor * membro.adicional / 100
        }
        if (membro.desconto !== 0) {
          valor -= membro.desconto
        }
        valor = parseInt(valor * 100) / 100
        membro.valorLiquido = valor
      }
      return membro.valorLiquido.toFixed(2)
    },
    evaluationToggleLiquidValue (membro) {
      membro.valorZerado = !membro.valorZerado
      this.evaluationLiquidValue(membro)
    },
    enviarNotaLote (contrato) {
      var notas = []
      var valida = ''

      this.gridItemsLot.forEachNode((rowNode, index) => {
        if (rowNode.data != null) {
          if (rowNode.data.fator != null) {
            var valor = rowNode.data.fator

            if (valor > 1) {
              valida = 'O fator máximo é 1.0'
            }

            if (valor < 0) {
              valida = 'O fator mínimo é 0'
            }
          }
        }
      })

      if (valida !== '') {
        toast.error(valida)
        return
      }

      this.gridItemsLot.forEachNode((rowNode, index) => {
        if (rowNode.data != null) {
          if (rowNode.data.fator != null) {
            notas.push({
              Fator: rowNode.data.fator,
              ItemID: rowNode.data.id,
              PDRDepartamento: rowNode.data.departamento,
              Descricao: rowNode.data.item
            })
          }
        }
      })

      var metodo = contrato ? PDRObraAvaliacaoRepository.PostLotEvaluationContract : PDRObraAvaliacaoRepository.PostPDRLotEvaluation

      loading.push()
      metodo(this.selectedPdrObraID, notas)
        .then(() => {
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    sendBonusFormCommon () {
      loading.push()

      const membros = this.formCheckListBonus.membros.map(i => {
        return {
          obraMembroID: i.obraMembroID,
          valorBruto: i.valorBruto,
          valorLiquido: i.valorLiquido,
          reducao1: i.reducao1,
          reducao2: i.reducao2,
          adicional: i.adicional,
          observacoes: i.observacoes,
          valorZerado: i.valorZerado,
          desconto: i.desconto,
          ocultar: i.ocultar,
          pdrLiberado: i.pdrLiberado
        }
      })

      let valorParsed = this.formCheckListBonus.valor
      if (typeof (this.formCheckListBonus.valor) === 'string') {
        valorParsed = this.formCheckListBonus.valor.replaceAll('.', '').replace(',', '.')
        valorParsed = parseFloat(valorParsed)
      }

      return {
        valor: valorParsed,
        tipoBonificacao: this.formCheckListBonus.tipoBonificacao,
        membros: membros,
        observacao: this.formCheckListBonus.observacao,
        checkAtAntesTermObra: this.formCheckListBonus.checkAtAntesTermObra,
        checkDocComplTerm: this.formCheckListBonus.checkDocComplTerm,
        checkPo: this.formCheckListBonus.checkPo,
        percFat: this.formCheckListBonus.percFat
      }
    },
    sendBonusFormPartial () {
      if (this.sendingBonus) {
        return
      }

      let formularioEnvio = this.sendBonusFormCommon()

      this.sendingBonus = true
      PDRRepository.SetCheckListBonusPartial(this.formCheckListBonus.pdrid, formularioEnvio)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          this.sendingBonus = false
          loading.close()
        })
    },
    sendBonusForm () {
      if (this.sendingBonus) {
        return
      }

      const formularioEnvio = this.sendBonusFormCommon()

      let hasNegativeValue = false
      formularioEnvio.membros.forEach(m => {
        if (m.valorLiquido < 0) {
          hasNegativeValue = true
        }
      })
      if (hasNegativeValue) {
        toast.error(this.$lang.PCI.PDR.NegativeValueAlert)
        loading.close()
        return
      }

      this.sendingBonus = true
      PDRRepository.SetCheckListBonus(this.formCheckListBonus.pdrid, formularioEnvio)
        .then((response) => {
          if (response.data.code > 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.showFormBonus = false
            this.onLoad()
          } else {
            toast.error(response.data.message)
          }
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => {
          this.sendingBonus = false
          loading.close()
        })
    },
    formatTeamUnit (employee) {
      return {
        id: employee.id,
        name: employee.nome,
        function: () => {
          return this.$lang.PCI.PDR.StatusFunction['_' + employee.funcao]
        },
        labor: () => {
          return this.$lang.PCI.PDR.StatusLablr['_' + employee.tipoMaoDeObra]
        },
        type: () => {
          return this.$lang.PCI.PDR.StatusServiceType['_ ' + employee.tipoServico]
        },
        startDate: employee.inicioAtividades ? moment(employee.inicioAtividades).toDate().toLocaleDateString() : '',
        endDate: employee.terminoAtividades ? moment(employee.terminoAtividades).toDate().toLocaleDateString() : '',
        days: () => {
          let startDate = employee.inicioAtividades ? moment(employee.inicioAtividades).startOf('day') : moment()
          let endDate = employee.terminoAtividades ? moment(employee.terminoAtividades).startOf('day') : moment()
          return endDate.diff(startDate, 'days')
        },
        status: employee.status === 1 ? 'Ativo' : 'Inativo',
        obs: employee.observacoes
      }
    },
    viewCOPof (params) {
      PCIRepository.GetPCIWork(params.node.data.obraId)
        .then(response => {
          if (response.data.code > 0) {
            this.pci = response.data.data[0].Data[0]
            this.showCopOf = true
            this.$nextTick(() => {
              this.$refs.cop.show(this.pci)
            })
          }
        })
    },
    onHideCop () {
      this.showCopOf = false
    },
    onViewTeam () {
      this.showConstructionTeam = true
      this.$nextTick(() => {
        this.$refs.team.show(this.pci)
      })
    },
    formatTeam (data) {
      let team = data.map(employee => (
        this.formatTeamUnit(employee)
      ))
      return team
    },
    viewTeam (obraId, setTeam = true) {
      this.obraIDSelected = obraId

      loading.push()

      WorkRepository.GetTeam(this.obraIDSelected)
        .then(response => {
          // Verifies response status
          if (response.data.code > 0) {
            // Get team data
            this.teamRowData = this.formatTeam(response.data.data)

            this.gridApi.stopEditing()
            // Show team modal
            this.showTeam = setTeam
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => loading.close())
    },
    viewArchivePdr (params) {
      const statuspdr = parseInt(params.node.data.statuspdr)
      if (statuspdr < 10) {
        toast.error('Essa PDR não foi totalmente Avaliada!')
        return
      }
      this.showArchivePdr = true
      this.editArchiveObservation = null
      this.selectedPdrObraID = params.node.data.id
    },
    archivePdr (response) {
      if (!response) this.showArchivePdr = false
      if (response) {
        loading.push()
        PDRRepository.Archive({pdrObraID: this.selectedPdrObraID, observacao: this.editArchiveObservation})
          .then(() => {
            this.workRowData = this.workRowData.filter(row => {
              return row.id !== this.selectedPdrObraID
            })
            this.$nextTick(() => {
              this.totalWorkRows = this.workDataGridOptions.api.rowModel.rowsToDisplay.length
              toast.success(this.$lang.Common.Alerts.Success)
            })
            this.showArchivePdr = false
          })
          .catch(() => {
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            this.selectedPdrObraID = null
            loading.close()
          })
      }
    },
    resumoXLS (params) {
      loading.push()
      PDRRepository.GetResumeXLS(params.node.data.id)
        .then(response => {
          console.log(response)

          var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          var url = window.URL.createObjectURL(blob)

          window.open(url) // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    getContextMenuItems (params) {
      let plan2Avaliado = false
      const planejamento = params.api.columnModel.columnDefs.find(cd => cd.headerName === 'PLANEJAMENTO')
      if (planejamento) {
        const plan2 = planejamento.children.find(c => c.headerName === 'PLANEJAMENTO 2')
        if (plan2) {
          const plan2Termino = plan2.children.find(p => p.headerName === 'Termino')
          if (plan2Termino) {
            plan2Avaliado = !!params.node.data[plan2Termino.field]
          }
        }
      }

      return [
        {
          name: this.$lang.PCI.PDR.Contexts.BonificationForm,
          action: () => { this.viewBonusForm(params) },
          cssClasses: [this.hasRole(Roles.RW_OPER_PCI_PDR_BONUS) &&
            params.node.selected &&
            (params.node.data.statuspdr === '9' || // analisada e conferida
            (params.node.data.statuspdr === '10' && plan2Avaliado) || // analise final
            params.node.data.statuspdr === '11' || // analisada
            params.node.data.statuspdr === '13' || // rejeitado diretor técnico
            params.node.data.statuspdr === '16' || // rejeitado gerente engenharia
            params.node.data.statuspdr === '22') // finalizada parcial
            ? '' : 'd-none'],
          icon: '<i class="fas fa-money-check-alt"></i>'
        },
        {
          name: this.$lang.PCI.PDR.Contexts.SendResume,
          action: () => { this.sendPDRPendencies(params) },
          cssClasses: [this.hasRole(Roles.RW_OPER_PCI_PDR_BONUS) && params.node.selected && !this.isArchived ? '' : 'd-none'],
          icon: '<i class="far fa-envelope"></i>'
        },
        {
          name: this.$lang.PCI.PDR.Contexts.StoppageHistory,
          action: () => { this.viewStoppageHistory(params) },
          cssClasses: [params.node.selected ? '' : 'd-none'],
          icon: '<i class="fas fa-history"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.HistoricPDR,
          action: () => { this.viewPdrLog(params) },
          cssClasses: [params.node.selected ? '' : 'd-none'],
          icon: '<i class="fas fa-history"></i>'
        },
        {
          name: this.$lang.PCI.Spreadsheet.ExclusionPDR,
          action: () => { this.viewExclusionPdr(params) },
          cssClasses: [this.hasRole(Roles.RW_OPER_PCI_PDR_EXCLUSION) && params.node.selected && params.node.data.statuspdr <= 11 ? '' : 'd-none'],
          icon: '<i class="fas fa-trash-restore-alt"></i>'
        },
        {
          name: this.$lang.PCI.COP.ViewOfficial,
          action: () => { this.viewCOPof(params) },
          icon: '<i class="fas fa-camera"></i>',
          shortcut: 'F6'
        },
        {
          name: this.$lang.PCI.PDR.Contexts.Archive,
          action: () => { this.viewArchivePdr(params) },
          cssClasses: [this.hasRole(Roles.RW_OPER_PCI_PDR_BONUS) && params.node.selected && !this.isArchived ? '' : 'd-none'],
          icon: '<i class="fas fa-file-archive"></i>'
        },
        {
          name: this.$lang.PCI.PDR.Contexts.ExcelExport,
          action: () => { this.exportExcel(params) },
          icon: '<i class="far fa-file-excel"></i>'
        }
      ]
    },
    onEditFinalEvaluation (event) {
      let newValue = event.newValue ? event.newValue.toString() : ''
      let obraId = event.data.id

      var chamada
      // if (event.colDef.field === 'terminoanalisefinal') {
      //   chamada = PDRObraAvaliacaoRepository.PostEndFinalAnalysis
      // } else
      if (event.colDef.field === 'inicioparalisacao') {
        chamada = PDRObraAvaliacaoRepository.PostStartStoppage
      } else if (event.colDef.field === 'terminoparalisacao') {
        chamada = PDRObraAvaliacaoRepository.PostEndStoppage
      } else if (event.colDef.field === 'motivoparalisacao') {
        chamada = PDRObraAvaliacaoRepository.PostMotiveStoppage
      // } else if (event.colDef.field === 'inicioanalisediretortecnico') {
      //   chamada = PDRObraAvaliacaoRepository.PostStartTechnicalDirector
      // } else if (event.colDef.field === 'terminoanalisediretortecnico') {
      //   chamada = PDRObraAvaliacaoRepository.PostEndTechnicalDirector
      // } else if (event.colDef.field === 'inicioanalisediretoradministrativo') {
      //   chamada = PDRObraAvaliacaoRepository.PostStartAdministrativeDirector
      // } else if (event.colDef.field === 'terminoanalisediretoradministrativo') {
      //   chamada = PDRObraAvaliacaoRepository.PostEneAdministrativeDirector
      // } else if (event.colDef.field === 'conclusao') {
      //   chamada = PDRObraAvaliacaoRepository.PostConclusion
      } else if (event.colDef.field === 'documentopendente') {
        chamada = PDRObraAvaliacaoRepository.PostDocumentPendencies
      // } else if (event.colDef.field === 'observacao') {
      //   chamada = PDRObraAvaliacaoRepository.PostFinalObservation
      }

      if (chamada) {
        chamada(obraId, { value: newValue })
          .then((response) => {
            if (response.data.code === -400) {
              event.node.data[event.colDef.field] = event.oldValue
              toast.error(response.data.message)
              event.api.refreshCells()
            } else {
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(() => {
            // Set a error toast
            toast.error(this.$lang.Common.CouldNotSave)

            // Rollback field value
            event.node.data[event.colDef.field] = event.oldValue
            event.api.refreshCells()
          })
      } else {
        // Rollback field value
        event.node.data[event.colDef.field] = event.oldValue
        event.api.refreshCells()
      }
    },
    selectItemEvaluationForm (param) {
      if (param.rowIndex !== this.evaluationCurrentRowIndex) {
        this.evaluationCurrentRowIndex = param.rowIndex
        if (param.api.getModel().getRow(param.rowIndex) && param.api.getModel().getRow(param.rowIndex).data) {
          this.itemImage = 'data:image/image/png;base64,' + param.api.getModel().getRow(param.rowIndex).data.imagem
          this.itemObservation = param.api.getModel().getRow(param.rowIndex).data.observacao_item
          this.selectedItemForm = param.api.getModel().getRow(param.rowIndex).data.id
        }
      }
    },
    sendPDRPendencies () {
      loading.push()

      PDRObraAvaliacaoRepository.PostDepartamentEmailPendencies()
        .then(() => {
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(() => {
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    viewBonusForm (params) {
      const statuspdr = parseInt(params.node.data.statuspdr)
      if (statuspdr < 10) {
        toast.error('Preencha as notas de todos os membros.')
        return
      }

      if (statuspdr > 11 && statuspdr !== 13 && statuspdr !== 22) {
        toast.error('Essa Obra já foi avaliada e está sendo validada.')
        return
      }

      loading.push()
      PDRRepository.GetCheckListBonus(params.node.data.id)
        .then(response => {
          this.formCheckListBonus = response.data.data

          const mInicio = moment(this.formCheckListBonus.inicioObra)
          const mTermino = moment(this.formCheckListBonus.terminoObra)

          this.formCheckListBonus.inicioObra = mInicio.toDate().toLocaleDateString()
          this.formCheckListBonus.terminoObra = mTermino.toDate().toLocaleDateString()
          this.formCheckListBonus.analiseFinal = moment(this.formCheckListBonus.analiseFinal).toDate().toLocaleDateString()
          this.formCheckListBonus.prazoObra = mTermino.diff(mInicio, 'days') + 1
          this.setCustomDisplayData()
          this.setCustomPropsDisplayData()
          this.showFormBonus = true
        })
        .finally(() => loading.close())
    },
    setCustomDisplayData () {
      if (this.formCheckListBonus.membros) {
        this.formCheckListBonus.membros.forEach((m, idx) => {
          // notas menores que 5.9 zera valor liquido
          m.valorZerado = m.nota < 5.9
          // if (m.nota < 5.9) {
          //   this.evaluationToggleLiquidValue(m)
          // }
          if (!m.pdrPago) {
            m.pdrLiberado = true
          }
          const member = this.teamRowData.find(mm => mm.id === m.obraMembroID)
          m.duplicado = this.teamRowData.filter(mm => mm.funcionarioId === member.funcionarioId).length > 1
          // adiciona coluna situação Rh no modal
          const item = this.teamRowData.find(t => t.nome === m.nome)
          if (item) {
            m.situacaoRh = item.situacaoRH
          }
        })
      }
    },
    setCustomPropsDisplayData () {
      const item = this.workRowData.find(f => f.referencia === this.formCheckListBonus.obra)
      if (item) {
        this.formCheckListBonus.libAvaliacao = moment(item.libavaliacaopdr).toDate().toLocaleDateString()
        this.formCheckListBonus.prazoPdr = this.getDaysDiference(item.libavaliacaopdr, this.formCheckListBonus.terminoObra)
      }
    },
    getDaysDiference (dateA, dateB) {
      if (!dateA || !dateB || dateA === '' || dateB === '') {
        return ''
      }
      const dtBsplit = dateB.split('/')
      const nDateA = new Date(dateA)
      const nDateB = new Date(dtBsplit[2], (dtBsplit[1] - 1), dtBsplit[0])
      const msDiference = nDateA - nDateB
      const daysDiference = msDiference / (1000 * 60 * 60 * 24)
      return daysDiference - (daysDiference % 1)
    },
    viewStoppageHistory (params) {
      loading.push()
      WorkPCIRepository.GetStoppages(params.node.data.obraId)
        .then(response => {
          this.showStoppageHistory = true
          this.stoppageHistory = []
          response.data.data.forEach(i => {
            this.stoppageHistory.push({
              inicioParalisacao: i.inicioParalisacao ? moment(i.inicioParalisacao).toDate().toLocaleDateString() : '',
              terminoParalisacao: i.terminoParalisacao ? moment(i.terminoParalisacao).toDate().toLocaleDateString() : '',
              observacao: i.observacao
            })
          })
          this.showStoppageHistory = true
        })
        .finally(() => loading.close())
    },
    viewPdrLog (params) {
      loading.push()
      PDRObraAvaliacaoRepository.GetLog(params.node.data.obraId)
        .then(response => {
          this.logPdr = []
          response.data.data.forEach(i => {
            this.logPdr.push({
              id: i.id,
              nomeContaAcao: i.nomeContaAcao,
              dataAcaoFormatada: i.dataAcaoFormatada,
              descricao: i.descricao
            })
          })
          this.showPdrLog = true
        })
        .finally(() => loading.close())
    },
    viewExclusionPdr (params) {
      this.showExclusionPdr = true
      this.editExclusionObservation = null
      this.selectedObraID = params.node.data.obraId
    },
    exclusionPdr (exclusion) {
      if (exclusion) {
        if (this.editExclusionObservation === null) {
          toast.error(this.$lang.PCI.PDR.ExclusionPDR.ValidationMessage)
          return
        }
        const h = this.$createElement
        let messageVNode = h('div', [
          h('h4', [
            this.$lang.PCI.PDR.ExclusionPDR.MessageValidation
          ]),
          h('br')
        ])
        this.$bvModal.msgBoxConfirm([messageVNode], {
          title: this.$lang.PCI.PDR.ExclusionPDR.TitleValidation,
          centered: true,
          okTitle: this.$lang.Common.Yes,
          okVariant: 'third',
          cancelTitle: this.$lang.Common.No,
          cancelVariant: 'danger',
          headerClass: 'justify-content-center'
        })
          .then((value) => {
            if (value) {
              loading.push()
              PDRObraAvaliacaoRepository.DeleteAvaliacao(this.selectedObraID, { Value: this.editExclusionObservation })
                .then(response => {
                  if (response.data.code > 0) {
                    toast.success(this.$lang.Common.Alerts.Success)
                    this.onLoad()
                  } else {
                    toast.error(response.data.message)
                  }
                })
                .catch(() => {
                  toast.error(this.$lang.Common.Alerts.Error)
                })
                .finally(() => {
                  this.showExclusionPdr = false
                  loading.close()
                })
            }
          })
      } else {
        this.showExclusionPdr = false
      }
    },
    onEvaluationOrder () {
      if (this.selectedObraID) {
        this.$refs.evaluationOrder.show(this.selectedObraID)
      }
    },
    onGridFormReady (params, formularioId) {
      let form = this.gridItemsForm.find(i => i.formularioID === formularioId)
      form.gridApi = params.api
    },
    onGridItemsFormReady (params) {
      this.gridItemsLot = params.api
      params.api.expandAll()
      // this.$nextTick(() => {
      //   params.api.sizeColumnsToFit()
      // })
    },
    onGridPdrReady (params) {
      this.gridPdr = params.api
      this.gridPdrColumns = params.columnApi
    },
    onGridMembersReady (params) {
      this.gridItemsLot = params.api
    },
    onTabClicked (item) {
      const formulario = this.gridItemsForm.find(i => i.formularioID === item.id)
      let members = formulario.gridApi.selectionService.getSelectedRows()
      if (members.length > 0) {
        this.workMemberID = members[0].id
        this.workMemberName = 'PDF avaliação de ' + members[0].nome
      } else {
        this.resetPdfButton()
      }
      this.$nextTick(() => {
        formulario.gridApi.columnModel.autoSizeAllColumns(true)
      })
    },
    processDataFromClipboard (params) {
      const currentCell = params.api.getFocusedCell()
      let currentRow = currentCell.rowIndex
      if (currentCell.column.colId === 'fator') {
        if (isEqual(params.data[params.data.length - 1], [''])) params.data.splice(params.data.length - 1, 1)

        params.data.forEach(row => {
          const rowGrid = params.api.rowModel.getRow(currentRow).data
          const rowData = this.formItems.grid.Data.find(d => d.id === rowGrid.id)
          const rowNode = params.api.getRowNode(rowData.id)
          let fator = 0
          let observacao = null
          if (row.length === 2) {
            fator = parseFloat(row[0].replace(',', '.'))
            fator = isNaN(fator) ? null : fator
            observacao = row[1]
          }
          if (row.length > 2) {
            fator = parseFloat(row[0].replace(',', '.'))
            fator = isNaN(fator) ? null : fator
            observacao = row[2]
          }
          if (row.length === 1) {
            fator = parseFloat(row[0].replace(',', '.'))
            fator = isNaN(fator) ? null : fator
            observacao = rowData.observacao
          }
          if (fator < 0 || fator > 1) {
            toast.error('O fator deve estar entre 0 e 1.')
          } else {
            const avaliacao = {
              ObraMembroID: this.selectedMemberID,
              PDRObraID: this.selectedPdrObraID,
              PDRFormularioItemID: rowData.id,
              Fator: fator,
              Observacao: observacao
            }

            rowData.fator = fator
            rowData.observacao = observacao
            params.api.refreshCells({force: true})
            this.work2update.push({event: {node: rowNode}, avaliacao})
            // loading.push()
            // PDRObraAvaliacaoRepository.PostPDREvaluation(avaliacao)
            //   .then(response => {
            //     if (response.data.code > 0) {
            //       rowData.fator = fator
            //       rowData.observacao = observacao
            //       rowData.nota = response.data.data.nota
            //       params.api.refreshCells({force: true})
            //     }
            //   })
            //   .catch(error => {
            //     console.log(error)
            //     toast.error(this.$lang.Common.Alerts.Error)
            //   })
            //   .finally(() => loading.close())
          }
          currentRow++
        })
      }
      if (currentCell.column.colId === 'observacao') {
        const row = params.data.map(d => [d[0]])
        return row
      }
      return null
    },
    onStopEditFactor (event) {
      this.evaluationEditing = false

      var valor = event.newValue

      if (valor > 1) {
        return
      }

      if (this.evaluationPressEnter) {
        const currentCell = this.itemsEvaluationDataGridOptions.api.getFocusedCell()
        const finalRowIndex = this.itemsEvaluationDataGridOptions.api.rowModel.getRowCount() - 1

        if (currentCell.rowIndex === finalRowIndex) {
          this.itemsEvaluationDataGridOptions.api.setFocusedCell(currentCell.rowIndex, currentCell.column)
          return
        }

        var qt = this.itemsEvaluationDataGridOptions.api.rowModel.getRow(currentCell.rowIndex + 1).data ? 1 : 2

        this.itemsEvaluationDataGridOptions.api.setFocusedCell(currentCell.rowIndex + qt, currentCell.column)
        this.itemsEvaluationDataGridOptions.api.startEditingCell({
          rowIndex: currentCell.rowIndex + qt,
          colKey: currentCell.column
        })
      }
    },
    editFator (event) {
      const valor = event.newValue

      if (valor > 1 || valor < 0) {
        toast.error('O fator deve estar entre 0 e 1.')
        event.node.data[event.colDef.field] = event.oldValue
        event.api.refreshCells()
        return
      }

      if (valor < 0) {
        toast.error('O fator mínimo é 0')
        event.node.data[event.colDef.field] = event.oldValue
        event.api.refreshCells()
        return
      }

      const avaliacao = {
        ObraMembroID: this.selectedMemberID,
        PDRObraID: this.selectedPdrObraID,
        PDRFormularioItemID: event.data.id,
        Fator: valor,
        Observacao: event.data.observacao
      }

      this.work2update.push({event, avaliacao})
      // loading.push()
      // PDRObraAvaliacaoRepository.PostPDREvaluation(avaliacao)
      //   .then(response => {
      //     const retorno = response.data.data
      //     event.node.setDataValue('nota', retorno.nota)
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     toast.error(this.$lang.Common.Alerts.Error)
      //   })
      //   .finally(() => loading.close())
    },
    postEditFactor () {
      loading.push()
      PDRObraAvaliacaoRepository.PostReprocDepartments(this.selectedPdrObraID)
        .then(response => {
          if (response.data.code > 0) {
            const retorno = response.data.data
            this.gridPdr.forEachNode((rowNode) => {
              if (rowNode.data.id === this.selectedPdrObraID) {
                rowNode.setDataValue('statuspdr', retorno.statusPdr)
                retorno.pdrObraDepartamentos.forEach(dep => {
                  rowNode.setDataValue('inicio_' + dep.pdrDepartamentoID, dep.inicioAvaliacao || null)
                  rowNode.setDataValue('termino_' + dep.pdrDepartamentoID, dep.terminoAvaliacao || null)
                  if (dep.inicioAvaliacao) {
                    rowNode.setDataValue('status_' + dep.pdrDepartamentoID, '2')
                  }
                  if (dep.terminoAvaliacao) {
                    rowNode.setDataValue('status_' + dep.pdrDepartamentoID, '3')
                  }
                })
              }
            })
            this.loadItensFormulario(this.selectedPdrObraID, true)
            this.loadAvaliacaoFinal(this.selectedPdrObraID)
          }
        })
        .finally(() => loading.close())
    },
    editObservacao (event) {
      var valor = event.newValue

      const avaliacao = {
        ObraMembroID: this.selectedMemberID,
        PDRObraID: this.selectedPdrObraID,
        PDRFormularioItemID: event.data.id,
        Fator: event.data.fator,
        Observacao: valor
      }

      this.work2update.push({event, avaliacao})
      // loading.push()
      // PDRObraAvaliacaoRepository.PostPDREvaluation(avaliacao)
      //   .then(response => {
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     toast.error(this.$lang.Common.Alerts.Error)
      //   })
      //   .finally(() => loading.close())
    },
    onEditFator (event) {
      if (this.selectedMember == null) {
        return
      }

      if (event.colDef.field === 'fator') {
        this.editFator(event)
      } else if (event.colDef.field === 'observacao') {
        this.editObservacao(event)
      }
    },
    processUpdate () {
      if (!this.isProcessingUpdate) {
        this.isProcessingUpdate = true

        if (this.work2update.length) {
          let current = Promise.resolve()

          while (this.work2update.length) {
            const obj = this.work2update.shift()
            const avaliation = obj.avaliacao
            const event = obj.event
            current = current.then(() => {
              return PDRObraAvaliacaoRepository.PostPDREvaluation(avaliation)
                .then(response => {
                  event.node.setDataValue('nota', response.data.data.nota)
                })
                .catch(error => {
                  console.log(error)
                  toast.error(this.$lang.Common.Alerts.Error)
                })
            })
          }

          current.then(() => {
            this.isProcessingUpdate = false
          })
        } else {
          this.isProcessingUpdate = false
        }
      }
      this.processUpdateTimer = setTimeout(() => {
        this.processUpdate()
      }, 200)
    },
    selectItemsForm (formulario) {
      const item = this.gridItemsForm.find(i => i.formularioID === formulario)
      return item
    },
    async loadAvaliacaoFinal (obra) {
      loading.push()
      PDRObraAvaliacaoRepository.GetFinalEvaluation(obra)
        .then(response => {
          const columnDefs = response.data.data.Headers

          if (this.isArchived) {
            const changeEditable = (col) => {
              if (col.children) {
                col.children.forEach(c => changeEditable(c))
              } else {
                col.editable = false
              }
            }
            columnDefs.forEach(c => changeEditable(c))
          }

          this.finalEvaluationColumnDefs = columnDefs
          this.finalEvaluationRowData = response.data.data.Data
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    async loadItensFormulario (obra, reload = false) {
      loading.push()
      if (!reload) {
        this.gridItemsForm = []
      }
      PDRObraAvaliacaoRepository.GetPDRFormEvaluation(obra)
        .then(response => {
          response.data.data.forEach(data => {
            const idx = this.gridItemsForm.findIndex(f => f.formularioID === data.formularioID)
            if (idx < 0) this.gridItemsForm.push(data)
            else {
              data.gridApi = this.gridItemsForm[idx].gridApi
              this.gridItemsForm.splice(idx, 1, data)
            }
          })
          // console.log(response.data.data)
          // this.gridItemsForm = response.data.data
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    async lotEvaluate (params) {
      console.log(params.node.data)
      loading.push()
      PDRObraAvaliacaoRepository.GetPDRLotEvaluation(params.node.data.id)
        .then(response => {
          this.selectedPdrObraID = params.node.data.id
          this.selectedMemberID = null
          this.selectedMember = response.data.data.membro
          this.formItems = response.data.data
          this.showModalEvaluation = true
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    async evaluateMember (params) {
      if (params.node.data.formularioPDRId === '') {
        return
      }
      const data = this.workDataGridOptions.api.getSelectedRows()[0]
      if (data && parseInt(data.statuspdr) > 10 && !this.archivedParams && parseInt(data.statuspdr) !== 22) {
        toast.error('A avaliação já foi concluída')
        return
      }
      const selectedWork = this.workDataGridOptions.api.getSelectedRows()[0] || {}
      loading.push()
      PDRObraAvaliacaoRepository.GetPDRMemberEvaluation(params.node.data.pdrobraid, params.node.data.id)
        .then(response => {
          if (response.data.code > 0) {
            this.selectedPdrObraID = params.node.data.pdrobraid
            this.selectedMemberID = params.node.data.id
            this.selectedMember = response.data.data.membro

            const workData = this.workRowData.find(w => w.id === params.node.data.pdrobraid)

            this.selectedMember.tipoObra = workData.tipo
            this.formItems = response.data.data
            this.formItems.membro.inicioAtividades = selectedWork.realizadoinicio
            this.formItems.membro.terminoAtividades = selectedWork.realizadotermino
            this.formItems.membro.diasCorridos = selectedWork.diascorridos
            this.formItems.membro.diasParalisado = selectedWork.diasparalisada
            this.formItems.membro.prazo = selectedWork.prazo
            this.formItems.grid.Data = response.data.data.grid.Data || []
            this.formItems.grid.Headers.forEach(h => {
              if (h.field === 'marcador') h.flex = 1
              if (h.field === 'peso') h.flex = 1
              if (h.field === 'fator') h.flex = 1
              if (h.field === 'fator') h.editable = h.editable && !this.archivedParams
              if (h.field === 'nota') h.flex = 1
              if (h.field === 'item') h.flex = 4
              if (h.field === 'observacao') h.flex = 5
            })
            this.showModalEvaluation = true
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    async generatePDF () {
      if (!this.workMemberID) {
        return
      }
      loading.push()
      PDRRepository.GetPDRWorkAppraisalPDF(this.workMemberID)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})

            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
          }
        })
        .catch(error => {
          console.log(error)
          toast.error(this.$lang.Common.Alerts.Error)
        })
        .finally(() => loading.close())
    },
    onShowEvaluationModal () {
      this.$nextTick(() => {
        document.getElementById('evaluationModal')
          .addEventListener('keydown', (evt) => {
            this.evaluationPressEnter = false
            if (evt.key === 'Enter' && this.evaluationEditing) {
              this.evaluationPressEnter = true
              // evt.stopPropagation()
              // evt.preventDefault()
              // const currentCell = this.itemsEvaluationDataGridOptions.api.getFocusedCell()
              // const finalRowIndex = this.itemsEvaluationDataGridOptions.api.rowModel.getRowCount() - 1

              // if (currentCell.rowIndex === finalRowIndex) {
              //   return
              // }

              // // this.itemsEvaluationDataGridOptions.api.clearFocusedCell()

              // var qt = this.itemsEvaluationDataGridOptions.api.rowModel.getRow(currentCell.rowIndex + 1).data ? 1 : 2

              // this.itemsEvaluationDataGridOptions.api.setFocusedCell(currentCell.rowIndex + qt, currentCell.column)
              // this.itemsEvaluationDataGridOptions.api.startEditingCell({
              //   rowIndex: currentCell.rowIndex + qt,
              //   colKey: currentCell.column
              // })
            }
          })
      })
    },
    async selectPdr (params) {
      this.selectedPdrObraID = null
      this.selectedObraID = null
      this.workMemberID = null
      this.workMemberName = null
      // this.totalWorkRows = this.gridPdr.filterManager.activeColumnFilters.length > 0
      //   ? this.gridPdr.rowRenderer.allRowCtrls.length
      //   : this.workRowData.length
      if (params.node.isSelected()) {
        loading.push()

        try {
          await this.loadItensFormulario(params.node.data.id)
          await this.loadAvaliacaoFinal(params.node.data.id)
        } catch (ex) {
          loading.close()
        }

        this.tabIndex = 0

        PDRRepository.GetPDRTeam(params.node.data.id)
          .then(response => {
            const data = response.data.data[0]

            this.selectedObraID = params.node.data.obraId
            this.selectedPdrObraID = data.Data == null ? null : data.Data[0].pdrobraid
            this.teamColumnDefs = data.Headers
            this.teamRowData = data.Data

            this.teamForms = []
            for (const membro of this.teamRowData) {
              if (membro.formularioPDRId !== '') {
                const formObject = { id: membro.formularioPDRId, nome: membro.formularioPDR }
                if (this.teamForms.findIndex(i => i.id === formObject.id) < 0) {
                  this.teamForms.push(formObject)
                }
              }
            }
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.Alerts.Error)
          })
          .finally(() => {
            loading.close()
            this.$nextTick(() => {
              this.teamDataGridOptions.columnApi.autoSizeAllColumns()
            })
          })
      }
    },
    membroFuncao (membro) {
      return `${membro.nome} (${membro.funcao})`
    },
    resetPdfButton () {
      this.workMemberID = null
      this.workMemberName = 'Selecione um membro na lista abaixo'
    },
    hideStatusDone () {
      this.hideStatusDoneEnabled = !this.hideStatusDoneEnabled
      localStorage.setItem('hideStatusDoneEnabled', this.hideStatusDoneEnabled)
      if (this.hideStatusDoneEnabled === true) {
        this.workRowData = this.workRowDataOrigin.filter(d => {
          let hasNotFinished = false

          for (var opt in d) {
            if (opt.startsWith('status_')) {
              hasNotFinished = hasNotFinished || d[opt] < 3
            }
          }

          return hasNotFinished
        })
      } else {
        this.workRowData = this.workRowDataOrigin
      }
      // this.totalWorkRows = this.workRowData.length
      this.$nextTick(() => {
        this.totalWorkRows = this.workDataGridOptions.api.rowModel.rowsToDisplay.length
      })
    },
    memberSelected (params) {
      if (params.node.isSelected()) {
        this.workMemberID = params.data.id
        this.workMemberName = 'PDF avaliação de ' + params.data.nome
      }
    },
    onFilterPdrChanged (params) {
      this.totalWorkRows = params.api.rowModel.rowsToDisplay.length
    },
    exportExcel (params) {
      const self = this
      const excelParams = {
        processCellCallback (params) {
          if (params.column.colDef.field.length > 6 && params.column.colDef.field.substring(0, 7) === 'status_') {
            return params.value === '0' ? '' : self.$lang.PCI.PDR.StatusDepartament['_' + params.value]
          }
          if (params.column.colDef.field === 'statuspdr') {
            return self.$lang.PCI.PDR.Status['_' + params.value]
          }
          if (params.column.colDef.field === 'pagamentoimpresso') {
            return params.value === 'true' ? 'Sim' : 'Não'
          }
          if (typeof params.value === 'string' && /^\d{2}\/\d{2}\/\d{4}/.test(params.value)) {
            const valueMoment = moment(params.value.substring(0, 10), 'DD/MM/YYYY')
            const newValue = valueMoment.format('YYYY-MM-DD')
            return newValue
          }

          return params.value
        }
      }

      this.workDataGridOptions.api.exportDataAsExcel(excelParams)
    },
    onToolPanelVisibleChanged (params) {
      if (params.source === 'layout') {
        const panel = params.api.getToolPanelInstance('layout')
        panel.onLoad()
      }
    },
    clearLayoutAndFilters () {
      const filter = {}
      this.gridPdr.setFilterModel(filter)
      this.gridPdrColumns.resetColumnState()
    }
  },
  mounted () {
    this.onDocumentKeydown = event => {
      if (this.workDataGridOptions.api && this.workDataGridOptions.api.getSelectedRows().length) {
        const rowNode = {
          data: this.workDataGridOptions.api.getSelectedRows()[0]
        }

        if (event.key === 'F6') {
          event.preventDefault()
          event.stopPropagation()
          this.viewCOPof({node: rowNode})
        }
      }
    }

    this.onDocumentKeyup = event => {
      const input = document.getElementById('fatValor')
      if (input && input.id === document.activeElement.id) {
        let inputId = input.id
        let focusId = document.activeElement.id
        if (inputId === focusId) {
          var v = event.target.value.replace(/\D/g, '')
          v = (v / 100).toFixed(2) + ''
          v = v.replace('.', ',')
          v = v.replace(/(\d)(\d{3})(\d{3}),/g, '$1.$2.$3,')
          v = v.replace(/(\d)(\d{3}),/g, '$1.$2,')
          event.target.value = v
        }
      }
    }

    document.addEventListener('keydown', this.onDocumentKeydown)
    document.addEventListener('keyup', this.onDocumentKeyup)

    this.processUpdate()
  },
  beforeDestroy () {
    // chamado 20103: sem isso o loop de 200ms e os listeners sobreviviam ao componente destruido
    if (this.processUpdateTimer) {
      clearTimeout(this.processUpdateTimer)
      this.processUpdateTimer = null
    }

    document.removeEventListener('keydown', this.onDocumentKeydown)
    document.removeEventListener('keyup', this.onDocumentKeyup)
  },
  beforeMount () {
    Tools.MinimizedSidebar()
    this.onLoad()
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/pdr/pdr.js